export const API_URL = process.env.API_URL || 'https://api.themoviedb.org/3';
export const API_KEY = process.env.API_KEY || '985b6732c229227d090a82fbed387761';
